import React,{ Component } from 'react';
import { connect } from 'react-redux';

import { Link, Prompt } from 'react-router-dom';
import "./Cart.css";

import { removeItem,addQuantity,subtractQuantity} from './Actions/cartActions';

class Cart extends Component{
    
    handleRemove = (id)=>{
        this.props.removeItem(id);
    }
    handleAddQuantity = (id)=>{
        this.props.addQuantity(id);
    }
    handleSubtractQuantity = (id)=>{
        this.props.subtractQuantity(id);
    }
    
    
    render(){
              
        let addedItems = this.props.items.length ?
            (  
                this.props.items.map(item=>{
                    return(
                        
                        <li  key={item.id}>
                            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" integrity="sha512-iBBXm8fW90+nuLcSKlbmrPcLa0OT92xO1BIsZ+ywDWZCvqsWgccV3gFoRBv0z+8dLJgyAHIhR35VZc2oM/gI w==" crossorigin="anonymous" referrerpolicy="no-referrer" />  
                                    <div className="super">
                                    <div className="cartcontent">
                                    <div className="item-img"> 
                                        <img src={item.img}  />
                                    </div>
                                    <div className="iteminfo">
                                    <div className="item-desc">
                                        <span className="title">{item.title}</span>
                                        <p>{item.desc}</p>
                                        <p><b>Price: {item.price}$</b></p> 
                                        <p>
                                            <b>Quantity: {item.quantity}</b> 
                                        </p>
                                        
                                        <div className="add-remove">
                                            <Link to="/Cart"><i onClick={()=>{this.handleAddQuantity(item.id)}} class="fas fa-chevron-up"></i></Link>
                                            <Link to="/Cart"><i onClick={()=>{this.handleSubtractQuantity(item.id)}} class="fas fa-chevron-down"></i></Link>
                                        </div>
                                        </div>
                                        <button className="removebtn" onClick={()=>{this.handleRemove(item.id)}}  >Remove</button>
                                        </div>
                                    </div>
                                    </div>
                               
                               </li>                        
                        
                        
                   )
                   
                })
                
            ):

             (  <h5>
                <p><i class="fas fa-frown-open noorder"></i>Nothing </p></h5>
             )
       
        return(
            <div className="container2">
                <div className="cart">
                    <h3><br/></h3>
                    <h5>You have ordered:</h5>
                        <ul className="collection">
                        {addedItems}
                        <div className="checkoutcontainer">
                        <Link to="/Modal">
                        <button className="checkout">Proceed to checkout</button>
                        </Link>
                        </div>
                        
                        
                        
                    </ul>
                </div>  
                
            </div>
       )
    }
}

const mapStateToProps = (state)=>{
    return{
        items: state.addedItems
    }
}
const mapDispatchToProps = (dispatch)=>{
    return{
        removeItem: (id)=>{dispatch(removeItem(id))},
        addQuantity: (id)=>{dispatch(addQuantity(id))},
        subtractQuantity: (id)=>{dispatch(subtractQuantity(id))}
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Cart);

